import { makeRequest } from './request.service';

export const getCropsAnalyticsSummaryData = async farmId => {
  try {
    const response = await makeRequest({
      method: 'GET',
      url: `/dashboard/${farmId}/crops-analytics-summary`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('secret')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Crops Analytics summary data:', error);
    throw error;
  }
};
